module.exports = __webpack_public_path__ + "static/media/illu-multicanal.a3439262.png";